import autocomplete from "autocompleter";
const input = document.getElementById('hint');

if (typeof (input) !== 'undefined' && input != null) {
  let tableOfHint;
  const allowedChars = new RegExp(/^[a-zA-Z\s]+$/);

  const charsAllowed = (value) => {
    return allowedChars.test(value);
  }

  const jsonCall = async () => {
    // w przypadku locala
    const source = await fetch('workshop.json')
    // produkcja
    //const source = await fetch('/searchform_names_json/')
      .then(response => {
        return response.json();
      })
      .then((myJson) => {
        tableOfHint = myJson;
        autocomplete({
          input: input,
          fetch: function (text, update) {
            text = text.toLowerCase();
            console.log(tableOfHint);
            const suggestions = tableOfHint.filter(n => n.name.toLowerCase()
              .startsWith(text));
            update(suggestions);
          },
          debounceWaitMs: 200,
          onSelect: function (item) {
            input.value = item.name;
          },
          render: function (item, value) {
            const itemElement = document.createElement('div');
            if (charsAllowed(value)) {
              const regex = new RegExp(value, 'gi');
              const inner = item.name.replace(regex, function (match) {
                return '<strong>' + match + '</strong>';
              });
              itemElement.innerHTML = inner;
            } else {
              itemElement.textContent = item.name;
            }
            return itemElement;
          },
          emptyMsg: 'Keine Werkstätten gefunden',

          className: 'autocomplete-customizations',
        });
      })

      .catch((error) => {
        console.error('Error:', error);
      });
  };
  let jsonCalled = false
  input.addEventListener('focus', (e) => {
    if(!jsonCalled) {
      jsonCall();
      jsonCalled = true;
    }
  });
}
